export function rupiah(n) {
  const num = Number(n || 0);
  return "Rp " + num.toLocaleString("id-ID");
}

export function effectivePrice(p) {
  if (p.is_promo && p.promo_percent) {
    return Math.round(p.price * (100 - p.promo_percent) / 100);
  }
  return p.price;
}

export const FASMART_CATS = ["Sembako", "Minuman", "Snack & Biskuit", "Mie Instan", "Bumbu & Saus", "Kebersihan Rumah", "Perawatan Diri", "Ibu & Bayi", "Perlengkapan Rumah", "Obat & Kesehatan", "Alat Tulis & Kantor", "EsKrim & FrozenFood"];

export const CATEGORY_MARGIN = {
  "Sembako": 6, "Mie Instan": 7, "Ibu & Bayi": 8, "Bumbu & Saus": 12,
  "Kebersihan Rumah": 14, "Perawatan Diri": 16, "Minuman": 18, "Snack & Biskuit": 18,
  "Obat & Kesehatan": 20, "Perlengkapan Rumah": 25, "Alat Tulis & Kantor": 25,
  "EsKrim & FrozenFood": 20,
};

export function suggestPrice(category, modal) {
  const m = Number(modal || 0);
  if (m <= 0) return 0;
  const pct = (CATEGORY_MARGIN[category] ?? 15) / 100;
  return Math.round(m / (1 - pct) / 100) * 100;
}

export function branchStock(p, branchId) {
  if (!FASMART_CATS.includes(p.category) || !branchId) return p.stock ?? 0;
  return p.stock_by_branch?.[branchId] ?? 0;
}

export function branchPrice(p, branchId) {
  if (FASMART_CATS.includes(p.category) && branchId && p.price_by_branch?.[branchId] != null) {
    return p.price_by_branch[branchId];
  }
  return p.price;
}

export function tierInfo(tier) {
  const map = {
    Warga: { label: "Warga Biasa", color: "bg-stone-200 text-stone-700", next: 150000, prev: 0 },
    Langganan: { label: "Langganan Setia", color: "bg-amber-200 text-amber-900", next: 500000, prev: 150000 },
    Juragan: { label: "Juragan FASMART", color: "bg-emerald-200 text-emerald-900", next: null, prev: 500000 },
  };
  return map[tier] || map.Warga;
}

export function statusInfo(s) {
  const map = {
    baru: { label: "Pesanan Baru", color: "bg-amber-100 text-amber-800 border-amber-300" },
    diterima: { label: "Pesanan Diterima", color: "bg-teal-100 text-teal-800 border-teal-300" },
    cek_transfer: { label: "Cek Transferan", color: "bg-indigo-100 text-indigo-800 border-indigo-300" },
    akan_dikirim: { label: "Akan Dikirim", color: "bg-violet-100 text-violet-800 border-violet-300" },
    disiapkan: { label: "Sedang Disiapkan", color: "bg-sky-100 text-sky-800 border-sky-300" },
    dikirim: { label: "Diantar Kurir", color: "bg-indigo-100 text-indigo-800 border-indigo-300" },
    selesai: { label: "Selesai", color: "bg-emerald-100 text-emerald-800 border-emerald-300" },
    dibatalkan: { label: "Dibatalkan", color: "bg-rose-100 text-rose-800 border-rose-300" },
  };
  return map[s] || map.baru;
}

// Jam operasional warung: 06.00–22.00 WIB
export function warungOpen() {
  const h = Number(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Jakarta", hour: "numeric", hour12: false })
  );
  return h >= 6 && h < 22;
}

export function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
